"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Acts as an intermediary between the application and the persistence layer.
 *
 * Includes typesafety and transformations to ensure that the data is stored
 * correctly and allow for migrations
 *
 * @param T The name of the keyspace we'll be storing data in
 * @param V The schema of the data we'll be storing
 * @param persistance The persistance controller we'll be using to store the data
 * It's what actually stores the data
 * @param defaultValue The default value for the data, which if provided, will be used
 * if no data is found in the persistance layer
 *
 */
class StorageController {
    constructor({ namespace, schema, persistance, defaultValue, }) {
        this.schema = schema;
        this.namespace = namespace;
        this.persistance = persistance;
        this.defaultValue = defaultValue;
    }
    /**
     * What we use to get data
     *
     * TODO: The typing is working properly--if we provide a default value, we should
     * not have to handle the null case.
     *
     * @param key The key we're storing the data under, can be null to use the default key
     * @returns
     */
    async get(key = null) {
        const value = await this.persistance.getValue(this._getKey(key));
        if (!value) {
            if (this.defaultValue !== undefined) {
                return this.defaultValue;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return null;
        }
        return this.schema.parse(JSON.parse(value));
    }
    /**
     *  Updates the data in the storage controller
     *
     *
     * @param key The key we're storing the data under, can be null to use the default key
     * @param value The value we're storing
     * @returns void
     *
     */
    async set(key = null, value) {
        // First we validate the data
        this.schema.parse(value);
        // Then we stringify it
        const stringValue = JSON.stringify(value);
        await this.persistance.setValue(this._getKey(key), stringValue);
    }
    /**
     * Deletes the data in the storage controller
     *
     * @param key The key we're storing the data under, can be null to use the default key
     * @returns void
     *
     */
    async delete(key = null) {
        await this.persistance.deleteValue(this._getKey(key));
    }
    // ==============================
    // Private methods
    // ==============================
    _getKey(key) {
        return `staffbar:${this.namespace}:${key || "default"}`;
    }
}
exports.default = StorageController;
